import styled from '@emotion/styled';
import tokens from '@vaa-component-lib/shared.design-tokens/json/variables.json';
import { BreakPointToken } from '../../hooks/useMediaQuery';

const {
	spacing: {
		size_8px: { height: size_8 },
		size_16px: { height: size_16 },
		size_40px: { height: size_40 }
	}
} = tokens;

export const DropDownList = styled.ol<{ maxHeight?: boolean }>`
	padding: 0;
	margin: 0;
	list-style: none;

	${({ maxHeight }) =>
		maxHeight &&
		`
		@media (max-width: ${BreakPointToken.SmMax}px) {
			max-height: ${10 * size_40}px;
		}
	`}
`;

export const DropDownListLi = styled.li``;

export const DropDownListGroup = styled.div`
	h6 {
		padding: ${size_8}px ${size_16}px;
	}
`;
